// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MangoHubVerifyPatientRequest {
    static getAttributeTypeMap() {
        return MangoHubVerifyPatientRequest.attributeTypeMap;
    }
}
MangoHubVerifyPatientRequest.discriminator = undefined;
MangoHubVerifyPatientRequest.attributeTypeMap = [
    {
        "name": "activationCode",
        "baseName": "activationCode",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "birthDate",
        "baseName": "birthDate",
        "type": "Date"
    },
    {
        "name": "zipCode",
        "baseName": "zipCode",
        "type": "string"
    }
];
//# sourceMappingURL=mangoHubVerifyPatientRequest.js.map